import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject, bindable, observable } from 'aurelia-framework';
import { getAutocompleteTypeFromProductSource } from 'elements/input-autocomplete-type';
import { ErpSystem } from 'models';
import { Models } from 'models/core';
import { ErpSystemService } from 'services/erp-system-service';
import { ErrorService } from 'services/error-service';
import { ProductService } from 'services/product-service';

@autoinject
export class DetergentTypeForm {
  @bindable
  @observable
  private detergentType: Models.DetergentType;
  detergentTypeChanged(detergentType: Models.DetergentType) {
    if (detergentType?.Id) {
      void this.setProductName(detergentType.ProductId);
    }
  }

  protected articleNo = '';
  protected isDuplicate = false;

  protected inputAutocompleteType: string = 'generalproduct';
  protected erpSystemSelected = false;
  protected erpSystems: ErpSystem[] = [];

  constructor(
    private productService: ProductService,
    private errorService: ErrorService,
    private eventAggregator: EventAggregator,
    private erpSystemService: ErpSystemService
  ) {
    void this.getErpSystems();
  }

  private attached() {
    this.eventAggregator.subscribe('detergentTypeIsDuplicate', (isDuplicate) => {
      this.isDuplicate = isDuplicate;
    });
  }

  protected setProductId(event: { detail: { value: string } }) {
    const productId = Number(event.detail.value);
    this.detergentType.ProductId = productId;
    void this.setProductName(productId);
  }

  private async setProductName(productId: number) {
    try {
      if (productId) {
        const product = await this.productService.get(productId);
        this.detergentType.Name = product.Name;
        this.detergentType.NameEn = product.Name;
        this.detergentType.NameEs = product.Name;
        this.articleNo = product.ArticleNo;
      }
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  protected async getErpSystems() {
    this.erpSystems = await this.erpSystemService.getAll();
  }

  protected setErpSystem(erpSystemProductSource: string) {
    this.inputAutocompleteType = getAutocompleteTypeFromProductSource(erpSystemProductSource);
    this.erpSystemSelected = true;
  }
}
